export enum AppLocaleEnum {
  NL = 'nl',
  EN = 'en',
}
